import { format } from "date-fns";
import { CalendarIcon, X } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";

export const DatePicker = ({ value, onChange, placeholder, testId }) => (
  <Popover>
    <div className="relative">
      <PopoverTrigger asChild>
        <Button variant="outline" data-testid={testId} className="w-full justify-start font-normal text-left">
          <CalendarIcon className="h-4 w-4 mr-2 text-muted-foreground" />
          {value ? format(value, "dd MMM yyyy") : <span className="text-muted-foreground">{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      {value && (
        <button type="button" onClick={() => onChange(null)} className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground" aria-label="Clear date">
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
    <PopoverContent className="w-auto p-0" align="start">
      <Calendar mode="single" selected={value} onSelect={(d) => onChange(d || null)} initialFocus />
    </PopoverContent>
  </Popover>
);
